<template>
  <div class="page view_geolocation">
    <div class="geolocation_img">
	    <img :src="geolocation_img" alt="L'agglo Herault Mediterrannee"/>

    </div>

    <div class="buttonWrapper">
      <router-link to="/Place" class="buttonLink">Vous êtes à la borne {{borne_number}}</router-link>
    </div>
  </div>
</template>

<script>

import ImgPlace1 from '@/assets/geolocation_place1.jpg'
import ImgPlace2 from '@/assets/geolocation_place2.jpg'
import ImgPlace3 from '@/assets/geolocation_place3.jpg'
import ImgPlace4 from '@/assets/geolocation_place4.jpg'
import ImgPlace5 from '@/assets/geolocation_place5.jpg'

export default {
  name: 'geolocation',
  components: {},
  props: {
    place: String
  },
  data: () => ({
    target: null
  }),
  mounted: function() {
    var target = this.place || "place1";

    if (this.authorized_target.indexOf(target) == -1) {
      throw new Error(`Target ${target} not available`);
    }

    this.target = target;
    window.localStorage.setItem('target', target);
  },
  methods: {
  },
  computed: {
    authorized_target: () => ([
      "place1",
      "place2",
      "place3",
      "place4",
      "place5",
    ]),
    borne_number: function() {
      return this.authorized_target.indexOf(this.target) + 1
    },
    geolocation_img: function() {
      var imgs = {
        place1: ImgPlace1,
        place2: ImgPlace2,
        place3: ImgPlace3,
        place4: ImgPlace4,
        place5: ImgPlace5,
      };

      return imgs[this.target];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  
  .view_geolocation {

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .geolocation_img {
      height: 100%;
      max-height: calc(100% - 80px);
      // margin: -20px -20px 10px;
      padding-bottom: 20px;
      overflow: hidden;

      @media only screen and (min-width: 500px) {
        padding: 20px;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .buttonLink {
      margin-bottom: 20px;
    }

    .buttonWrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/Geolocation.vue